import { useState, useEffect } from 'react';

const navItems = [
  { label: '홈', href: '#home' },
  { label: '회사소개', href: '#about' },
  { label: '제품서비스', href: '#products' },
  { label: '산업설비', href: '#industrial' },
  { label: '도장설비', href: '#painting' },
  { label: '연락처', href: '#contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('home');

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);

      const sections = ['home', 'about', 'products', 'industrial', 'painting', 'contact'];
      for (let i = sections.length - 1; i >= 0; i--) {
        const el = document.getElementById(sections[i]);
        if (el && window.scrollY >= el.offsetTop - 120) {
          setActiveSection(sections[i]);
          break;
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMenuOpen(false);
    const id = href.replace('#', '');
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-sm' : 'bg-transparent'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 lg:px-12 flex items-center justify-between h-20">
        {/* Logo */}
        <a
          href="#home"
          onClick={(e) => { e.preventDefault(); handleNavClick('#home'); }}
          className="flex items-center gap-3 cursor-pointer"
        >
          <img
            src="https://public.readdy.ai/ai/img_res/1f13c3a0-d7e2-4d47-86d7-8998576e56ab.png"
            alt="(주)에스제이엔지니어링 로고"
            className="h-12 w-auto object-contain"
          />
        </a>

        {/* Desktop Nav */}
        <ul className="hidden lg:flex items-center gap-8">
          {navItems.map((item) => {
            const sectionId = item.href.replace('#', '');
            const isActive = activeSection === sectionId;
            return (
              <li key={item.href}>
                <a
                  href={item.href}
                  onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
                  className={`whitespace-nowrap text-sm font-medium transition-colors duration-200 relative cursor-pointer
                    ${scrolled
                      ? isActive ? 'text-[#C0392B]' : 'text-[#1C1C1C] hover:text-[#C0392B]'
                      : isActive ? 'text-[#E8C27A]' : 'text-white hover:text-[#E8C27A]'
                    }
                  `}
                >
                  {item.label}
                  {isActive && (
                    <span className="absolute -bottom-1 left-0 right-0 h-0.5 bg-current rounded-full" />
                  )}
                </a>
              </li>
            );
          })}
        </ul>

        {/* CTA Button */}
        <a
          href="#contact"
          onClick={(e) => { e.preventDefault(); handleNavClick('#contact'); }}
          className="hidden lg:flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold whitespace-nowrap cursor-pointer transition-all duration-200 bg-[#C0392B] text-white hover:bg-[#A93226]"
        >
          <i className="ri-mail-send-line" />
          문의하기
        </a>

        {/* Mobile Menu Toggle */}
        <button
          className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer transition-colors ${scrolled ? 'text-[#1C1C1C]' : 'text-white'}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="메뉴 열기"
        >
          <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`} />
        </button>
      </nav>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-100 shadow-lg">
          <ul className="flex flex-col py-4">
            {navItems.map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
                  className="block px-6 py-3 text-sm font-medium text-[#1C1C1C] hover:text-[#C0392B] hover:bg-gray-50 cursor-pointer transition-colors"
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
}
